'use strict';

exports.__esModule = true;
exports.default = typeof window !== 'undefined' && typeof window.document !== 'undefined';
module.exports = exports['default'];